module.exports = __webpack_public_path__ + "img/inspector.a6a7fc2e.svg";